/**
 * Builder > Integration > Icon
 * <ua-builder-integration-icon>
 */

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { getIntegrationIconURL } from '@automator/builder/_legacy/js/integrations/utilities';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'ua-builder-integration-icon' )
export class IntegrationIcon extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: String } ) accessor code;

	@property( { type: String } ) accessor size = 'regular';

	@property( { type: Boolean } ) accessor plain;

	// eslint-disable-next-line require-jsdoc, no-useless-constructor
	constructor() {
		super();
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div 
				class="icon"
				size=${ this.size }
				plain=${ ifDefined( this.plain ) }
			>
				<img src="${ getIntegrationIconURL( { integrationCode: this.code } ) }">
			</div>
		`;
	}
}
